"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = exports.ContractAddresses = void 0;
exports.ContractAddresses = {
    80001: '0x56c35dF413b3cd753f85427e55A8dF66A79f1bd7',
    137: '0xd429262030B75De758Ff807282405fc3b32F8416'
};
exports.environment = {
    test: {
        bouncerURL: 'http://localhost:3000',
        bouncerRPCURL: 'http://localhost:3000/spkz/rpc',
        defaultProvider: 'https://speedy-nodes-nyc.moralis.io/337ce5317ffe1f66093a6c3b/polygon/mumbai',
        roomContractAddress: exports.ContractAddresses['80001'],
        chainId: '80001',
        networkdId: '80001'
    },
    dev: {
        bouncerURL: 'https://dev.bouncer.spkz.io',
        bouncerRPCURL: 'https://dev.bouncer.spkz.io/spkz/rpc',
        defaultProvider: 'https://speedy-nodes-nyc.moralis.io/337ce5317ffe1f66093a6c3b/polygon/mumbai',
        roomContractAddress: exports.ContractAddresses['80001'],
        chainId: '80001',
        networkdId: '80001'
    },
    uat: {
        bouncerURL: 'https://uat.bouncer.spkz.io',
        bouncerRPCURL: 'https://uat.bouncer.spkz.io/spkz/rpc',
        defaultProvider: 'https://speedy-nodes-nyc.moralis.io/337ce5317ffe1f66093a6c3b/polygon/mumbai',
        roomContractAddress: exports.ContractAddresses['80001'],
        chainId: '80001',
        networkdId: '80001'
    },
    prod: {
        bouncerURL: 'https://bouncer.spkz.io',
        bouncerRPCURL: 'https://bouncer.spkz.io/spkz/rpc',
        defaultProvider: 'https://speedy-nodes-nyc.moralis.io/337ce5317ffe1f66093a6c3b/polygon/mainnet',
        roomContractAddress: exports.ContractAddresses['137'],
        chainId: '137',
        networkdId: '1'
    }
};
//# sourceMappingURL=environment.js.map